"use strict";
/**
 * @isg/shared-types — backend + web + (ileride) mobil ortak tipleri.
 *
 * KURAL: Buraya yalnızca üç katmanın da paylaştığı tipler girer.
 * Yalnızca API'yi ilgilendiren bir tip apps/api içinde kalır.
 *
 * Faz 0 Session 1 kapsamı: yalnızca /health sözleşmesi + marka (branded) id
 * yardımcıları. Alan enum'ları (PermitStatus, HazardClass vb.) alan adı
 * konvansiyonu kesinleşince (Session 2) eklenecek.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ROLE_TYPES = exports.asUserId = exports.asTenantId = void 0;
const asTenantId = (value) => value;
exports.asTenantId = asTenantId;
const asUserId = (value) => value;
exports.asUserId = asUserId;
/**
 * v1 şapka listesi (Kapsam §20.3 — 11 + izleyici; F1·S5). Şapka = görev türü,
 * HOLDING GENELİNDE; yalnız holding yöneticisi verir. `viewer` salt okunur —
 * guard GET/HEAD dışını uç listesine bakmadan reddeder. `physician`/`ysp`
 * tanımlıdır ama sağlık erişimi Faz 2'ye kadar hiçbir uca bağlanmaz.
 */
exports.ROLE_TYPES = [
    'holding_admin',
    'company_admin',
    'location_manager',
    'isg_specialist',
    'isg_technician',
    'physician',
    'ysp',
    'area_supervisor',
    'employee',
    'employee_rep',
    'contractor_rep',
    'viewer',
];
//# sourceMappingURL=index.js.map